import type { User } from "firebase/auth";

import React from "react";
import { useDispatch } from "react-redux";

import { AuthStateProvider as BaseAuthStateProvider } from "igfd-commons/src/auth";

import {
  type DashboardReducerDispatch,
  onUserIdChange,
} from "@dashboard/store/actions/adminUserActions";

import { mixpanelAuthChanged } from "../mixpanel/mixpanel";

export const AuthStateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const dispatch = useDispatch<DashboardReducerDispatch>();
  return (
    <BaseAuthStateProvider
      onAuthChange={(user: User | null) => {
        mixpanelAuthChanged(user);
        dispatch(onUserIdChange(user ? user.uid : null));
      }}
    >
      {children}
    </BaseAuthStateProvider>
  );
};
